<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_bf5"
      :custom="{storage: true}"
      export
      :refresh="{query: RefreshList}"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('vehicleViolation_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('vehicleViolation_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      :loading="loading"
      @sort-change="sortList"
    >
      <vxe-table-column
        type="checkbox"
        width="60"
        fixed="left"
      />
      <vxe-table-column>
        <vxe-table-column
          field="licenseNumber"
          title="车牌号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.licenseNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="classificationCode"
          title="车辆分类"
          :formatter="formatterVehicleClassification"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.classificationCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in vehicleClassificationList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
              clearable
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="violationSum"
          title="违章条数"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.violationSumStart"
                placeholder="下限"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'violationSumStart')"
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.violationSumEnd"
                placeholder="上限"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'violationSumEnd')"
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="penaltyAmountSum"
          title="违章罚款合计"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.penaltyAmountSumStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.penaltyAmountSumEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="deductPointsSum"
          title="违章记分合计"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deductPointsSumStart"
                placeholder="下限"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'deductPointsSumStart')"
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.deductPointsSumEnd"
                placeholder="上限"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'deductPointsSumEnd')"
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column
        title="操作"
        
        fixed="right"
        width="60"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('vehicleViolation_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="code => showModel(scope.row.vehicleCode, 'Detail')"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelDetailFlag"
      title="详情"
      width="1200"
      height="600"
      resize
      @close="hideVehicleModal"
    >
      <compDetail ref="DetailRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
  import compDetail from "./components/vehicleViolationDetail.vue";
  import { vehicleViolation } from "@/api/vehicleService";
  import { getListDict } from "@/api/commonApi";
  export default {
    name: "VehicleViolationList",
    components: {
      compDetail
    },
    data() {
      return {
        exportObj:{
          exportUrl:"/ntocc-basic-api/vehicleViolation/exportVehicleViolationList",//导出接口
          name:'车辆违章'
        },
        loading: false,
        tableData: [],
        modelAddFlag: false,
        modelEditFlag: false,
        modelDetailFlag: false,
        vehicleClassificationList: [],
        listQuery: {
          pageNum: 1,
          pageSize: 20,
          sortField: "",
          sortType: "",
          total: 0
        }
      };
    },
    created() {
      // 获取数据字典： 车型，车长，车宽，车高，吨位，定位来源
      getListDict({
        types:
          "vehicleClassification,vehicleLength,vehicleWidth,vehicleHigh,vehicleTonnage,locationSource"
      }).then(response => {
        this.vehicleClassificationList = response.data.filter(
          item => item.type === "vehicleClassification"
        )[0]["dictList"];
        this.findList();
      });
    },
    methods: {
      findList() {
        this.loading = true;
        return new Promise(resolve => {
          vehicleViolation(this.listQuery).then(response => {
            this.tableData = response.data.records;
            this.listQuery.total = response.data.total;
            this.loading = false;
            resolve();
          });
        })
      },
      hideVehicleModal(){
        this.listQuery.pageNum = 1;
        this.findList();
      },
      // 翻译车型
      formatterVehicleClassification({ cellValue }) {
        const item = this.vehicleClassificationList.find(
          item => item.code === cellValue
        );
        return item ? item.name : "";
      },
      // 展示弹框
      showModel(code, prefix) {
        if (code) {
          this.$refs[`${prefix}Ref`].getInfo(code);
        }
        this[`model${prefix}Flag`] = true;
      },
      // 设置底部合计
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return "合计";
            }
            if (["pageviews", "forecast"].includes(column.property)) {
              return this.$XEUtils.sum(data, column.property);
            }
            return null;
          })
        ];
      }
    }
  };
</script>
